import {
  FileText, Sparkles, CreditCard, Presentation, GitBranch, Network,
  Award, ClipboardCheck, RefreshCcw, HelpCircle, ListChecks, FileCheck, ShieldCheck,
  BarChart3, FileSpreadsheet, Search, QrCode, Layers, Users, DoorOpen, Shield,
  MessageSquare, GraduationCap, Target, Eye, LayoutGrid,
} from 'lucide-react';

export const toolCategories = [
  {
    id: 'one-pagers',
    name: 'One-Pagers & Training Materials',
    description: 'Quick reference documents, cheat sheets, and educational handouts',
    icon: FileText,
    color: 'from-purple-500 to-indigo-600',
    bgColor: 'bg-purple-50',
    borderColor: 'border-purple-200',
    tools: [
      { id: 'one-pager', name: 'Training One-Pager', description: '20+ templates for staff education', icon: FileText, href: '/create', ready: true, featured: true },
      { id: 'policy-summarizer', name: 'Policy Summarizer', description: 'Upload a policy → meeting-ready infographic', icon: Sparkles, href: '/tools/policy-summarizer', ready: true, featured: true },
      { id: 'ai-assistant', name: 'AI Assistant', description: 'Generate materials with AI', icon: Sparkles, href: '/ai-assistant', ready: true, featured: true },
      { id: 'badge-buddy', name: 'Badge Buddy Cards', description: 'Clinical quick-reference for ID badges', icon: CreditCard, href: '/tools/badge-buddy', ready: true, featured: true },
      { id: 'poster', name: 'Poster Studio', description: 'Top-quality posters in any size — PNG, PDF & print', icon: Presentation, href: '/tools/poster', ready: true, featured: true },
      { id: 'process-guide', name: 'Step-by-Step Process', description: 'Sequential workflow guides & procedures', icon: GitBranch, href: '/tools/process-guide', ready: true, featured: true },
      { id: 'clinical-algorithm', name: 'Clinical Algorithm', description: 'YES/NO decision trees & protocols', icon: Network, href: '/tools/clinical-algorithm', ready: true, featured: true },
    ],
  },
  {
    id: 'training-competency',
    name: 'Training & Competency',
    description: 'Skills validation, testing, and orientation tracking',
    icon: GraduationCap,
    color: 'from-teal-500 to-cyan-600',
    bgColor: 'bg-teal-50',
    borderColor: 'border-teal-200',
    tools: [
      { id: 'certificate', name: 'Certificate Generator', description: 'Professional completion certificates', icon: Award, href: '/tools/certificate', ready: true, featured: true },
      { id: 'competency-checklist', name: 'Skills Competency', description: 'Annual validation checklists', icon: ClipboardCheck, href: '/tools/competency', ready: true },
      { id: 'return-demo', name: 'Return Demonstration', description: 'Skill verification forms', icon: RefreshCcw, href: '/tools/return-demo', ready: true },
      { id: 'pre-post-test', name: 'Pre/Post Test Generator', description: 'Auto-generate quizzes', icon: HelpCircle, href: '/tools/test-generator', ready: true },
      { id: 'orientation', name: 'Orientation Checklist', description: 'New hire training tracker', icon: ListChecks, href: '/tools/orientation', ready: true },
      { id: 'attestation', name: 'Staff Attestation', description: 'Policy acknowledgment & sign-off forms', icon: FileCheck, href: '/tools/attestation', ready: true },
      { id: 'consent-form', name: 'Consent Form', description: 'Informed consent with risks & signatures', icon: ShieldCheck, href: '/tools/consent', ready: true },
    ],
  },
  {
    id: 'quality-improvement',
    name: 'Quality Improvement',
    description: 'Problem-solving, root cause analysis, and performance improvement',
    icon: Target,
    color: 'from-amber-500 to-orange-600',
    bgColor: 'bg-amber-50',
    borderColor: 'border-amber-200',
    tools: [
      { id: 'smartsheet', name: 'SmartSheet', description: 'QI project tracking & data management', icon: BarChart3, href: '/tools/smartsheet', ready: true, featured: true },
      { id: 'a3-report', name: 'A3 Problem-Solving', description: 'Toyota-style improvement reports', icon: FileSpreadsheet, href: '/tools/a3', ready: true, featured: true },
      { id: 'rca', name: 'Root Cause Analysis', description: 'Fishbone & 5-Why templates', icon: GitBranch, href: '/tools/rca', ready: true },
      { id: 'audit-tool', name: 'Audit & Observation', description: 'Compliance observation tools', icon: Search, href: '/tools/audit', ready: true },
      { id: 'action-plan', name: 'Action Plan Tracker', description: 'PDSA cycles & corrective actions', icon: ListChecks, href: '/tools/action-plan', ready: true },
    ],
  },
  {
    id: 'visual-management',
    name: 'Visual Management',
    description: 'Huddle boards, signage, and safety displays',
    icon: Eye,
    color: 'from-emerald-500 to-green-600',
    bgColor: 'bg-emerald-50',
    borderColor: 'border-emerald-200',
    tools: [
      { id: 'qr-generator', name: 'QR Code Generator', description: 'Create scannable QR codes for materials', icon: QrCode, href: '/tools/qr-generator', ready: true, featured: true },
      { id: 'bulk-print', name: 'Bulk Print Center', description: 'Print orientation packets & bundles', icon: Layers, href: '/tools/bulk-print', ready: true, featured: true },
      { id: 'huddle-board', name: 'Huddle Board', description: 'Daily safety briefing templates', icon: Users, href: '/tools/huddle', ready: true },
      { id: 'door-sign', name: 'Door Signs', description: 'Isolation & precaution signage', icon: DoorOpen, href: '/tools/door-sign', ready: true },
      { id: 'tent-card', name: 'Tent Cards', description: 'Table tents & reminders', icon: CreditCard, href: '/tools/tent-card', ready: true },
      { id: 'safety-display', name: 'Safety Metrics Display', description: 'Days without incident boards', icon: Shield, href: '/tools/safety-display', ready: true },
    ],
  },
  {
    id: 'communication',
    name: 'Communication Tools',
    description: 'Standardized communication and handoff tools',
    icon: MessageSquare,
    color: 'from-blue-500 to-indigo-600',
    bgColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
    tools: [
      { id: 'sbar', name: 'SBAR Cards', description: 'Structured communication templates', icon: MessageSquare, href: '/tools/sbar', ready: true },
      { id: 'handoff', name: 'Handoff Tools', description: 'Shift change communication', icon: RefreshCcw, href: '/tools/handoff', ready: false },
    ],
  },
];

export const dashboardStats = [
  { label: 'Document Types', value: '20+', icon: LayoutGrid },
  { label: 'Templates', value: '50+', icon: FileText },
  { label: 'AI-Powered', value: 'Yes', icon: Sparkles },
  { label: 'Print Sizes', value: '7', icon: Presentation },
];

export const printSizes = [
  { id: 'letter', name: 'Letter', description: '8.5" × 11" (recommended)', category: 'standard' },
  { id: 'legal', name: 'Legal', description: '8.5" × 14"', category: 'standard' },
  { id: 'a4', name: 'A4', description: '8.27" × 11.69"', category: 'standard' },
  { id: 'half-letter', name: 'Half Letter', description: '5.5" × 8.5"', category: 'compact' },
  { id: 'quarter', name: 'Quarter Page', description: '4.25" × 5.5"', category: 'compact' },
  { id: 'tabloid', name: 'Tabloid', description: '11" × 17"', category: 'large' },
  { id: 'badge-large', name: 'Badge Large', description: '3" × 4"', category: 'badge' },
  { id: 'badge-standard', name: 'Badge', description: '2.5" × 3.5"', category: 'badge' },
  { id: 'badge-horizontal', name: 'Badge Horizontal', description: '3.5" × 2"', category: 'badge' },
  { id: 'tent-card', name: 'Tent Card', description: '4" × 3"', category: 'badge' },
];

export const colorSchemes = [
  { name: 'Teal', primary: '#0D9488', secondary: '#5EEAD4', background: '#F0FDFA', text: '#134E4A', accent: '#14B8A6' },
  { name: 'Indigo', primary: '#4F46E5', secondary: '#A5B4FC', background: '#EEF2FF', text: '#312E81', accent: '#6366F1' },
  { name: 'Rose', primary: '#E11D48', secondary: '#FDA4AF', background: '#FFF1F2', text: '#881337', accent: '#F43F5E' },
  { name: 'Amber', primary: '#D97706', secondary: '#FCD34D', background: '#FFFBEB', text: '#78350F', accent: '#F59E0B' },
  { name: 'Emerald', primary: '#059669', secondary: '#6EE7B7', background: '#ECFDF5', text: '#064E3B', accent: '#10B981' },
  { name: 'Blue', primary: '#2563EB', secondary: '#93C5FD', background: '#EFF6FF', text: '#1E3A8A', accent: '#3B82F6' },
  { name: 'Purple', primary: '#7C3AED', secondary: '#C4B5FD', background: '#F5F3FF', text: '#4C1D95', accent: '#8B5CF6' },
  { name: 'Slate', primary: '#475569', secondary: '#CBD5E1', background: '#F8FAFC', text: '#1E293B', accent: '#64748B' },
];

export const organizations = [
  { id: 'miramont', name: 'Miramont Behavioral Health', shortName: 'Miramont', type: 'behavioral-health', primaryColor: '#7C3AED', description: 'Mental health and behavioral health education materials' },
  { id: 'encompass', name: 'Encompass Rehab Hospital', shortName: 'Encompass', type: 'rehab', primaryColor: '#0D9488', description: 'Rehabilitation and infection prevention training materials' },
];
